import ColorConstants from '@/base/ColorConstants';
import { ProgressChartData } from './ProgressChartModel';

const DEFAULT_DATASET_SETTINGS = {
  fill: false,
  borderWidth: 1,
};

export const DATASET_INDEX_CURRENT = 0;
export const DATASET_INDEX_TARGET = 1;
export const DATASET_INDEX_TRACKER = 2;

export interface ProgressChartConfiguration extends Chart.ChartConfiguration {
  data: ProgressChartData;
};

export const getDefaultChartConfiguration = (): ProgressChartConfiguration => {
  return {
    type: 'bar',
    data: {
      labels: [],
      datasets: [
        {
          ...DEFAULT_DATASET_SETTINGS,
          label: 'Current',
          backgroundColor: (): string => ColorConstants.greenRGBA,
          borderColor: (): string => ColorConstants.greenRGB,
          data: [],
        },
        {
          ...DEFAULT_DATASET_SETTINGS,
          label: 'Target',
          borderDash: [10, 5],
          backgroundColor: (): string => ColorConstants.whiteRGBA,
          borderColor: (): string => ColorConstants.greenRGB,
          data: [],
        },
        {
          ...DEFAULT_DATASET_SETTINGS,
          label: 'Tracker',
          borderDash: [10, 5],
          backgroundColor: (): string => ColorConstants.redRGBA,
          borderColor: (): string => ColorConstants.redRGB,
          data: [],
        }
      ]
    },
    options: {
      plugins: {
        labels: {
          render: 'value',
          position: 'border',
          textMargin: -2
        }
      },
      tooltips: {
        enabled: false
      },
      responsive: true,
      scales: {
        yAxes: [{
          ticks: {
            beginAtZero: true,
          }
        }],
        xAxes: [{
          stacked: true,
          ticks: {
            beginAtZero: true
          }
        }]
      }
    }
  };
};
